import { createSlice } from "@reduxjs/toolkit";
import { multiStudentcreateAction, multiTeachercreateAction, organisationalSchoolListAction, schoolCsvListAction, schoolNewAdminsList, schoolParentIdListAction, schoolResetPassAction, schoolStatsAction, schoolStudentIdListAction, schoolTeacherIdListAction, schoolWorkerIdListAction, schooldetailsAction, schoollistAction } from "../Action/schoolAction";
const initialState = {
  schoollist:{},
  schooldetails: {},
  organisationalSchoolList: {},
  organisationalSchoolListStatus: "idle",
  schoolTeacherIdList:{},
  schoolStudentIdList:{},
  schoolParentIdList:{},
  schoolWorkerIdList:{},
  schoolManageAdminList:{},
  schoolResetPassStatus: "idle",
  multiTeachercreateStatus:"idle",
  multiStudentcreateStatus:"idle",
  schoolCsvListStatus:"idle"

}

const schoolSlice = createSlice({
  name: 'school',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(schoollistAction.fulfilled, (state, action) => {
        state.schoollist = action?.payload?.data;
      })
      .addCase(schoolStatsAction.fulfilled, (state, action) => {
        state.schoollist = action?.payload?.data;
      })
      .addCase(schooldetailsAction.fulfilled, (state, action) => {
        state.schooldetails = action?.payload?.data;
      })
      .addCase(organisationalSchoolListAction.pending, (state) => {
        state.organisationalSchoolListStatus = "pending";
      })
      .addCase(organisationalSchoolListAction.fulfilled, (state, action) => {
        state.organisationalSchoolList = action?.payload?.data;
        state.organisationalSchoolListStatus = "succeeded";
      })
      .addCase(organisationalSchoolListAction.rejected, (state) => {
        state.organisationalSchoolListStatus = "failed";
      })
      .addCase(schoolResetPassAction.fulfilled, (state, action) => {
        state.schoolResetPassStatus = 'succeeded';
      })
     
      .addCase(schoolTeacherIdListAction.fulfilled, (state, action) => {
        state.schoolTeacherIdList = action?.payload?.data;
      })

      .addCase(schoolStudentIdListAction.fulfilled, (state, action) => {
        state.schoolStudentIdList = action?.payload?.data;
      })

      .addCase(schoolParentIdListAction.fulfilled, (state, action) => {
        state.schoolParentIdList = action?.payload?.data;
      })

      .addCase(schoolWorkerIdListAction.fulfilled, (state, action) => {
        state.schoolWorkerIdList = action?.payload?.data;
      })

      .addCase(schoolNewAdminsList.fulfilled, (state, action) => {
        state.schoolManageAdminList = action?.payload?.data;
      })

      

      .addCase(schoolCsvListAction.fulfilled, (state, action) => {
        state.schoolCsvListStatus = action?.payload?.data;
      })

      
      
      .addCase(multiTeachercreateAction.fulfilled, (state, action) => {
        state.multiTeachercreateStatus = 'succeeded';
      })



      .addCase(multiStudentcreateAction.fulfilled, (state, action) => {
        state.multiStudentcreateStatus = 'succeeded';
      })

      
  },
});

export default schoolSlice.reducer;
